export enum InboxResponseType {
  REJECTED = 'Rejected'
}
